import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import moment from "moment";
import {
  TournamentVenueTypeEnum,
  ViewDateFormat,
  RoleEnum,
} from "../../constants/appConstant";
import AdvanceTable from "../../components/advanceTable";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import { useLocation, useNavigate } from "react-router-dom";
import { useQueryParams } from "../../contexts/queryParamsContext";
import { useSearchParams } from "react-router-dom";

const Tournaments = () => {
  const [id, setId] = useState();
  const [data, setData] = useState({});
  const [masterTournamentName, setMasterTournamentName] = useState("");
  const navigate = useNavigate();
  const { params, setParams ,resetParams} = useQueryParams();
  const [searchParams] = useSearchParams();
  let masterId;
  useEffect(() => {
    initialize();
    //getData(1);

    // return () => {
    //   setParams({
    //     ...params,
    //     masterTournamentId: null,
    //   });
    // };
  }, []);

  const initialize = async () => {
    debugger;
    //const fetchedId = null;
    const fetchedId = searchParams.get("masterTournamentId");
    // fetchedId=params.masterTournamentId;
    
    if (fetchedId) {
      setId(fetchedId);
      masterId = fetchedId;
      await getData(1, fetchedId);
    } else {
      await getData(1);
    }
  };

  const getData = async (
    pageNumber,
    masterTournamentId = null,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      "GetTournaments",
      {
        pageNumber: pageNumber,
        q: searchTerm,
        masterTournamentId: masterTournamentId,
        recordsToDisplay,
        sportId: null,
      },
      "Post"
    );
    debugger;
    if (response?.data) {
      if (masterId && response?.data?.[0]?.data?.[0]?.tournamentMasterName) {
        setMasterTournamentName(response.data[0].data[0].tournamentMasterName);
      }

      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          schedule: renderScheduleButton(item.isSchedule, item.id),
          rules: renderRulesButton(item.id),
          joinStatus: `${item.teamsJoined}/${item.maxTeams} teams joined`,
          venueType: Common.Utility.getKeyByValue(
            TournamentVenueTypeEnum,
            item.venueType
          ),
          registrationDates: `${moment(item.registrationStartDateTime).format(
            ViewDateFormat
          )} - ${moment(item.registrationEndDateTime).format(ViewDateFormat)}`,
          playingDates: `${moment(item.startDateTime).format(
            ViewDateFormat
          )} - ${moment(item.endDateTime).format(ViewDateFormat)}`,
        })),
      };

      setData(obj);
    }
  };

  const renderScheduleButton = (isSchedule, id) => {
    if (!isSchedule) return <div></div>;

    return (
      <div>
        <button
          style={{
            backgroundColor: "#2b2b8a",
            color: "white",
            padding: "6px 14px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
          onClick={() => {
            setParams({
              ...params,
              tournamentId: id,
            });
            navigate(`/app/tournamentScheduling`,{state:{masterTournamentId:masterId}});
          }}
        >
          Schedule
        </button>
      </div>
    );
  };

  const renderRulesButton = (id) => {
    return (
      <div>
        <button
          style={{
            backgroundColor: "#dba524",
            color: "white",
            padding: "6px 14px",
            borderRadius: "5px",
            border: "none",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "bold",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
          }}
          onClick={() => {
            setParams({
              ...params,
              tournamentId: id,
            });
            navigate(`/app/tournamentRules`);
          }}
        >
          Rules
        </button>
      </div>
    );
  };

  // const _addUpdateTrigger = (id) => {
  //   if (global.user.roleId === RoleEnum.Super_Admin) {
  //     return (
  //       <Button
  //         size="icon"
  //         variant="outline"
  //         color="secondary"
  //         className="h-7 w-7 mr-2"
  //         onClick={() => {
  //           setParams({
  //             ...params,
  //             tournamentId: id,
  //           });
  //           navigate(`/app/addTournament`);
  //         }}
  //       >
  //         <Icon icon="heroicons:pencil" className="h-4 w-4" />
  //       </Button>
  //     );
  //   }
  //   return null;
  // };

  //const actions = [
  //  {
  //    type: "edit",
  //    onClick: (val) => {
  //      global.log(val);
  //      navigate(`/app/addTournament?id=${val.id}`);
  //    },
  //    },

  const actions = [
    global.user.roleId === RoleEnum.Super_Admin
      ? {
          type: "edit",
          onClick: (val) => {
            setParams({
              ...params,
              tournamentId: val.id,
            });
            navigate(`/app/addTournament`, { state: { masterTournamentId: id } });
          },
        }
      : null,
  ].filter(Boolean);

  //{
  //  type: "view",
  //  visibleProp: "isSchedule",
  //  visibleValue: true,
  //  onClick: (val) => {
  //    navigate(`/app/tournamentScheduling?id=${val.id}`);
  //  },
  //},
  // {
  //   type: "customIcon",
  //   icon: "check",
  //   onClick: (val) => {
  //     alert("Testing ");
  //   },
  // },
  /*  ];*/

  let columns = [
    { title: "Icon", type: "image", key: "icon" },
    { title: "Tournament Names", type: "text", key: "name" },
    { title: "Sport Type", type: "text", key: "sportName" },
    { title: "Join Status", type: "text", key: "joinStatus" },
    { title: "Entry Fee", type: "text", key: "entryFee" },
    { title: "Type", type: "text", key: "venueType" },
    { title: "Registration Dates", type: "text", key: "registrationDates" },
    { title: "Playing Dates", type: "text", key: "playingDates" },
    { title: "Schedule", type: "html", key: "schedule" },
    { title: "Rules", type: "html", key: "rules" },
  ];

  const _addBtn = () => {
    if (global.user.roleId === RoleEnum.Super_Admin) {
      return (
        <Button onClick={() =>
        {
          // resetParams();
          setParams({...params,tournamentId:null})
          navigate("/app/addTournament", { state: { masterTournamentId: id } })}
        }
        >
          <span className="text-xl mr-1">
            <Icon icon="icon-park-outline:plus" />
          </span>
          Add Tournament
        </Button>
      );
    }
    return null;
  };

  return (
    <>
      {data?.data && (
        <AdvanceTable
          title={`${
            masterTournamentName ? masterTournamentName + " - " : ""
          }Categories`}
          columns={columns}
          data={data}
          getData={getData}
          addButton={_addBtn}
          showPagination
          showAddButton
          actionButtons={actions}
          // updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default Tournaments;
